import { ChartIntervalItem } from './types';
import { TIME_FRAMES } from '@/libs/common/chart';

export type ChartThemeOptions = {
  borderColor: string;
  textColor: string;
  backgroundColor: string;
  lineColor: string;
  lineWidth: number;
  fontSize: number;
  fontFamily: string;
};

export const chartLightOptions: ChartThemeOptions = {
  borderColor: 'rgba(19, 21, 23, 0.639)',
  textColor: 'rgba(19, 21, 23, 0.639)',
  backgroundColor: 'transparent',
  lineColor: 'rgba(19, 21, 23, 0.08)',
  lineWidth: 2,
  fontSize: 12,
  fontFamily: 'Inter',
};

export const chartDarkOptions: ChartThemeOptions = {
  borderColor: 'rgba(255, 255, 255, 0.639)',
  textColor: 'rgba(255, 255, 255, 0.639)',
  backgroundColor: 'transparent',
  lineColor: 'rgba(255, 255, 255, 0.08)',
  lineWidth: 2,
  fontSize: 12,
  fontFamily: 'Inter',
};

export const watermarkUrl = '/img/saker-logo-horizontal.png';

export const defaultPriceScaleOptions = {
  borderVisible: false,
  minimumWidth: 32,
  ticksVisible: false,
  autoScale: true,
};

export const defaultColors = [
  '#BF3030',
  '#BF6030',
  '#BF8F30',
  '#BFBF30',
  '#8FBF30',
  '#60BF30',
  '#30BF30',
  '#30BF60',
  '#30BF8F',
  '#30BFBF',
  '#308FBF',
  '#3060BF',
  '#3030BF',
  '#6030BF',
  '#8F30BF',
  '#BF30BF',
  '#BF308F',
  '#BF3060',
];

export const defaultIntervals: ChartIntervalItem[] = [
  {
    label: '1H',
    value: 1 * 60,
    frame: TIME_FRAMES.ONE_HOUR,
  },
  {
    label: '6H',
    value: 6 * 60,
    frame: TIME_FRAMES.SIX_HOURS,
  },
  {
    label: '1D',
    value: 24 * 60,
    frame: TIME_FRAMES.ONE_DAY,
  },
  {
    label: '1W',
    value: 7 * 24 * 60,
    frame: TIME_FRAMES.ONE_WEEK,
  },
  {
    label: 'All',
    value: -1,
    frame: TIME_FRAMES.ALL,
  },
];
